import { stagger } from '@angular/animations';

export const environment = {
  production: false,
  apiUrl: 'https://userverwaltung-api.cpit.dev',
  keycloakConfig: {
    url: 'https://auth.cpit.dev',
    realm: 'cpit-dev',
    clientId: 'cpit-userverwaltung-frontend',
  },
  stage: 'DEV',
};
